import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Schedule } from '../models/schedule';


@Injectable()
export class ScheduleInMemoryService {

  // private _inMemorySchedules = new InMemorySchedules();

  constructor() { }

  getAllSchedulesInfo(): Observable<Schedule[]> {
    return of([]);
  }
}
